import module from 'nominas/nomina/module.js'

const schema = {
  configuracion: {
    calcular_aguinaldo: 'boolean',
    calcular_viaticos: 'boolean',
    cobrar_impuesto_estatal: 'boolean',
    comision_porcentaje: 'number',
    complemento_aguinaldo: 'number',
    contiene_viaticos: 'boolean',
    fecha: 'date',
    fecha_final: 'date',
    fecha_inicial: 'date',
    fecha_pago: 'date',
    fondo_ahorro_porcentaje: 'number',
    id_regimen_fiscal: 'number',
    id_tipo_nomina: 'number',
    id_metodo_calculo_comision: 'number',
    id_metodo_calculo_suministro: 'number',
    impuesto_estatal: 'number',
    iva_porcentaje: 'number',
    piramidar: 'boolean',
    proratear_subsidio: 'boolean',
    salario_minimo: 'number',
    subsidio_mensual: 'number',
    porcentajeTarifa: 'number',
    diasMensual: 'number',
    topeSueldo: 'number',
    uma_importe: 'number',
    uma_valor_unidad_mixta: 'number',
    no_deducible: 'boolean',
    omitir_carga_social_pendiente: 'boolean',
    aplicar_ajuste_impuesto: 'boolean',
    tipo_calculo_id: 'number',
  },
}

export default class NominasNominaCalculoConfiguracion {
  constructor ($http) {
    this.$http = $http
  }

  get (idProyecto, idNomina) {
    return this.$http.get('/api/nominas/nomina/calculo/configuracion', {
      params: {
        id_proyecto: idProyecto,
        id_nomina: idNomina,
      },
      schema,
    })
  }
}

module.service('NominasNominaCalculoConfiguracion', NominasNominaCalculoConfiguracion)



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Calculo/Configuracion.js